var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "intro-container"
  }, [_vm._l((_vm.introData), function(item) {
    return [_c('h2', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "description"
    }, [_vm._v("\n      " + _vm._s(item.description) + "\n    ")])]
  }), _vm._v(" "), _c('md-snackbar', {
    ref: "snackbar"
  }, [_c('span', [_vm._v(_vm._s(_vm.errorMessage))])])], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7130753c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Hello.vue
// module id = l7g5
// module chunks = 1